import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { translate, isNullOrEmpty, } from '../../../utils/util';
import { Input, BackButton, Title, Subtitle, Button, ListPagination } from '../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { ENUMS, SITES, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';

const ReprocessSearch = (props) => {
    const [invoices, setInvoices] = useState([])
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [filterSearch, setFilterSearch] = useState({
        invoice: null
    })

    useEffect(() => {
        setInvoices([])
        setTotalPages(0)
        setCurrentPage(0)

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (refreshing) => {
        let filter = {
            reprocess: true,
            pending: true,
            notFinished: true,
            invoice: filterSearch.invoice,
            site: getSite(getVision()),
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        }

        props.getInvoices(filter, (c) => {
            let list = [];
            Object.assign(list, invoices);
            refreshing ? list = c.items : list.push(...c.items)
            setInvoices(list);
            setTotalPages(c.totalPages);
        });
    }

    const getSite = (vision) => {
        if (vision === VISIONS.Faasa) {
            return SITES.Faasa
        }
        else if (vision === VISIONS.FaasaCKD) {
            return SITES.FaasaCKD
        }
        return ''
    }

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const onClick = () => {
        setInvoices([])
        setCurrentPage(0);
        onSearch(true)
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('reprocess-monitor', 'physical-confirmation')} />
            <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('invoice', 'physical-confirmation')} />
            <div className="container-fluid" >
                <div className="container">
                    <div className="card">
                        <div id="formSearch" className="row" style={{ padding: '10px' }}>
                            <div className="input-field col s12">
                                <Input
                                    id="invoice"
                                    name="invoice"
                                    required={isNullOrEmpty(filterSearch.journey)}
                                    placeholder={translate('invoice', 'physical-confirmation')}
                                    type="text"
                                    defaultValue={filterSearch.invoice}
                                    onChange={onChange}
                                    onBlur={onChange}
                                />
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <Button full="true" onClick={() => onClick()} text={translate('search', 'general')} />
                            </div>
                        </div>
                    </div>
                    {invoices.length > 0 &&
                        <ListPagination
                            page={totalPages}
                            current={{ currentPage, setCurrentPage }}
                            data={invoices.map((item, index) => {
                                return (
                                    <Link
                                        style={{ display: 'block', padding: '10px', height: '60px' }}
                                        className="collection-item z-depth-1 "
                                        to={{ pathname: 'reprocessmonitor', state: { invoice: item.invoice, upload: true } }}
                                        key={`oi-${index}`}
                                    >
                                        <span className="sixth-text-color" style={{ display: 'block' }}>{item.invoice}</span>
                                        <span className="second-text-color"  >
                                            {translate('parts', 'general')}: {item.receiptsQuantity || '0'}
                                        </span>
                                    </Link>
                                );
                            })
                            }
                        />
                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.physicalConfirmationReducer.transmissions,
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        printSelect: state.physicalConfirmationReducer.printSelect,
        invoices: state.physicalConfirmationReducer.invoices,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        getInvoices: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getInvoices(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessSearch)));
